import React from "react";
import { useAnimatedNumber } from "./useAnimateNumber";

export default function RollingNumber({ value, size }) {
  const animated = useAnimatedNumber(value, 1000);

  const digits = animated.toString().split("");

  return (
    <>
      <div id="number" className={`flex overflow-hidden ${size} font-bold`}>
        {digits.map((digit, i) => (
          <div key={i} className="digit">
            <div
              className="digit-inner"
              style={{ transform: `translateY(-${digit * 10}%)` }}
            >
              {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
                <span key={n}>{n}</span>
              ))}
            </div>
          </div>
        ))}
      </div>

      <style>
        {`
        #number {
          transition: width 1.8s ease;
        }

        .digit {
          overflow: hidden;
          height: 1em;
          width: 0.7em;
        }

        .digit-inner {
          display: flex;
          flex-direction: column;
          transition: transform 0.6s ease;
        }

        .digit-inner span {
          height: 1em;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        `}
      </style>
    </>
  );
}
